import { sanitizeInput } from "../common/security-utils";

import tripIdIcon from "../../assets/svg/trip-id.svg";
import timeIcon from "../../assets/svg/time_ic.svg";
import truckIcon from "../../assets/svg/truck_ic.svg";
import addressIcon from "../../assets/svg/address_ic.svg";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";

const TripsListView = ({
    isLoading,
    tripsList,
    hoveredIndex,
    setHoveredIndex,
    checkPermission,
    navigate,
    setDeleteId,
}) => {
    return (
        <div className="w-100 trip-table-wrapper bg-white rounded-4 w-100 ">
            <div className="trips-table-header head3 w-100 justify-content-start align-items-center">
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={tripIdIcon} alt="tripid" className="me-1" /> TRIP ID
                </p>
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={timeIcon} alt="time" className="me-1" /> STARTS ON
                </p>
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor  text-start table-header-p">
                    <img src={timeIcon} alt="time" className="me-1" />
                    ENDS ON
                </p>{" "}
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={truckIcon} alt="truck" className="me-1" /> VEHICLE NAME
                </p>{" "}
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={truckIcon} alt="truck" className="me-1" /> VEHICLE ID
                </p>{" "}
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={addressIcon} alt="address" className="me-1" /> START ADDRESS
                </p>{" "}
                <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={addressIcon} alt="address" className="me-1" /> END ADDRESS
                </p>{" "}
            </div>
            <div>
                {isLoading
                    ? // Skeleton loading for list view
                    Array.from({ length: 5 }).map((_, index) => (
                        <div
                            key={`skeleton-${index}`}
                            className="trips-table-row head3 w-100 justify-content-center align-items-center"
                        >
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                            <div style={{ flex: "1" }} className="d-flex align-items-center">
                                <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }} />
                            </div>
                        </div>
                    ))
                    : (tripsList ?? []).map((item, index) => (
                        <div
                            className={`trips-table-row clickable ${hoveredIndex === index ? "hovered" : ""} head3 w-100 justify-content-center align-items-center`}
                            onClick={() => {
                                if (checkPermission("view_permission")) {
                                    navigate("/trips/view", {
                                        state: { id: item.id },
                                    });
                                }
                            }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            {" "}
                            <p
                                className="trips-table-cell fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.trip_id ?? "")}
                            >
                                {sanitizeInput(item.trip_id ?? "---")}
                            </p>
                            <p
                                className="trips-table-cell fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.trip_startdate ?? "")}
                            >
                                {sanitizeInput(item.trip_startdate ?? "---")}
                            </p>
                            <div
                                className="trips-table-cell-centered fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.trip_enddate ?? "")}
                            >
                                {" "}
                                {sanitizeInput(item.trip_enddate ?? "---")}
                            </div>
                            <div
                                className="trips-table-cell-centered fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.vehicle_name ?? "")}
                            >
                                {" "}
                                {sanitizeInput(item.vehicle_name ?? "---")}
                            </div>{" "}
                            <p
                                className="trips-table-cell fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.vin ?? "")}
                            >
                                {sanitizeInput(item.vin ?? "---")}
                            </p>
                            <p
                                className="trips-table-cell fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.start_address ?? "")}
                            >
                                {sanitizeInput(item.start_address ?? "---")}
                            </p>
                            <p
                                className="trips-table-cell fs-13 fw-500 textcolor text-start table-row-p"
                                title={sanitizeInput(item.location ?? "")}
                            >
                                {sanitizeInput(item.location ?? "---")}
                            </p>
                            {hoveredIndex === index && (
                                <div className="trips-action-icons-overlay">
                                    <div className="trips-action-btns-container">
                                        {checkPermission("edit_permission") && item.trip_status === "Created" && (
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate("/trips/create", {
                                                        state: { id: item.id },
                                                    });
                                                }}
                                                className="action-icon-circle-btn"
                                            >
                                                <img src={editIcon} alt="edit" />
                                            </div>
                                        )}
                                        <span style={{ marginLeft: "16px" }}></span>
                                        {checkPermission("delete_permission") && item.trip_status === "Created" && (
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setDeleteId(item.id);
                                                }}
                                                className="action-icon-circle-btn"
                                            >
                                                <img src={deleteIcon} alt="edit" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default TripsListView;
